<template>
    <div v-show="infoSidebar.info_sidebar" class="info-sidebar-container">
        <component 
            :is="getCurrentComponnet" 
            :detail-info="infoSidebar.info_details" 
            :info-sidebar-id="infoSidebar.info_sidebar_id"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormRecordingSidebarDetail from "@/components/SidebarDetail/FormRecordingSidebarDetail";
import EmptySidebarDetail from "@/components/SidebarDetail/EmptySidebarDetail";
import WorkflowSidebar from "@/components/SidebarDetail/WorkflowSidebar";
import FormSidebar from "@/components/SidebarDetail/FormSidebar";
import SubjectTypeSidebar from "@/components/SidebarDetail/SubjectTypeSidebar";
import SubjectSidebar from "@/components/SidebarDetail/SubjectSidebar";
import DataColumnSummarySidebar from "@/components/SidebarDetail/DataColumnSummarySidebar";
import TableConfigurationSidebar from "@/components/SidebarDetail/TableConfigurationSidebar";
import DashboardCardConfigurationSidebar from "@/components/SidebarDetail/DashboardCardConfigurationSidebar";
import PollenSidebar from "@/components/SidebarDetail/PollenSidebar";
import PollenBottleSidebar from "@/components/SidebarDetail/PollenBottleSidebar";
import BunchSidebar from "@/components/SidebarDetail/BunchSidebar";
import FreshSeedBagSidebar from "@/components/SidebarDetail/FreshSeedBagSidebar";
import FreshSeedBatchingSidebar from "@/components/SidebarDetail/FreshSeedBatchingSidebar";
import ProgramSidebar from "@/components/SidebarDetail/ProgramSidebar";
import TrialSidebar from "@/components/SidebarDetail/TrialSidebar";
import ProgenySidebar from "@/components/SidebarDetail/ProgenySidebar";
import GermplasmSidebar from "@/components/SidebarDetail/GermplasmSidebar";
import PalmSidebar from "@/components/SidebarDetail/PalmSidebar";
import GerminatedSeedSidebar from "@/components/SidebarDetail/GerminatedSeedSidebar";
import PollenProcessing1Sidebar from "@/components/SidebarDetail/PollenProcessing1Sidebar";
import PollenProcessing2Sidebar from "@/components/SidebarDetail/PollenProcessing2Sidebar";
import PollenQualityControlSidebar from "@/components/SidebarDetail/PollenQualityControlSidebar";
// import RoleSidebar from "@/components/SidebarDetail/RoleSidebar";

export default {
    name: "InfomationSidebar",
    components: {
        "form-recording-sidebar-detail": FormRecordingSidebarDetail,
        "empty-sidebar-detail": EmptySidebarDetail,
        "workflow-sidebar": WorkflowSidebar,
        "form-sidebar": FormSidebar,
        "subject-type-sidebar": SubjectTypeSidebar,
        "subject-sidebar": SubjectSidebar,
        "data-column-summary-sidebar": DataColumnSummarySidebar,
        "table-configuration-sidebar": TableConfigurationSidebar,
        "dashboard-card-configuration-sidebar": DashboardCardConfigurationSidebar,
        "bunch-sidebar": BunchSidebar,
        "pollen-sidebar": PollenSidebar,
        "pollen-bottle-sidebar": PollenBottleSidebar,
        "fresh-seed-bag-sidebar": FreshSeedBagSidebar,
        "fresh-seed-batching-sidebar": FreshSeedBatchingSidebar,
        "program-sidebar": ProgramSidebar,
        "trial-sidebar": TrialSidebar,
        "progeny-sidebar": ProgenySidebar,
        "germplasm-sidebar": GermplasmSidebar,
        "palm-sidebar": PalmSidebar,
        "germinated-seed-sidebar": GerminatedSeedSidebar,
        "pollen-processing-1-sidebar": PollenProcessing1Sidebar,
        "pollen-processing-2-sidebar": PollenProcessing2Sidebar,
        "pollen-quality-control-sidebar": PollenQualityControlSidebar,
        // "role-sidebar": RoleSidebar,
    },
    computed: {
        ...mapGetters([
            "infoSidebar",
        ]),
        getCurrentComponnet() {
            switch (this.infoSidebar.info_sidebar_category) {
            case "ROLE":
                return "role-sidebar";
            case "FORM_RECORDING":
                return "form-recording-sidebar-detail";
            case "POLLEN":
                return "pollen-sidebar";
            case "POLLEN_BOTTLE":
                return "pollen-bottle-sidebar";
            case "BUNCH":
                return "bunch-sidebar";
            case "FRESH_SEED_BAG":
                return "fresh-seed-bag-sidebar";
            case "BATCH_GERMINATION":
                return "fresh-seed-batching-sidebar";
            case "PROGRAM":
                return "program-sidebar";
            case "TRIAL":
                return "trial-sidebar";
            case "PROGENY":
                return "progeny-sidebar";
            case "GERMPLASM":
                return "germplasm-sidebar";
            case "PALM":
                return "palm-sidebar";
            case "GERMINATED_SEED_BAG":
                return "germinated-seed-sidebar";
            case "POLLEN_PROCESSING_1":
                return "pollen-processing-1-sidebar";
            case "POLLEN_PROCESSING_2":
                return "pollen-processing-2-sidebar";
            case "POLLEN_QUALITY_CONTROL":
                return "pollen-quality-control-sidebar";
            default:
                return "empty-sidebar-detail";
            }
        }
    }
};
</script>

<style lang="css" scoped>
.info-sidebar-container {
    width: var(--sidebar-info-size);
    border-left: 1px solid var(--border-line);
    height: calc(100vh - 50px - 2px);
    margin-top: 50px;
    padding: var(--space-24);
    overflow: auto;
    background-color: var(--pure-white);
}
.toggle {
	margin: 0.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/InfomationSidebar/index.vue